var map = {
	"./climaline-logo.png": "00f8",
	"./fantinicosmi-logo.png": "8a2f",
	"./hisense-logo.png": "b5b9",
	"./hitachi-logo.png": "6c2a",
	"./lg-logo.png": "54b7",
	"./midea-logo.png": "1b58",
	"./mitsubishi-electric-logo.png": "63e9",
	"./olimpia-splendid-logo.png": "89da",
	"./samsung-logo.png": "fd17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8bf";